import getMoreGroveButton from '../assets/logos/get-more-grove@2x.png';
import {useDispatch} from "react-redux";
import {ModalTypes} from "../constants";
import UIState from "../store/uiState";

export const GetMoreGroveButton = ({style}) => {
    const dispatch = useDispatch();

    return (
        <a className={'GetMoreGroveButton'}
             style={style}
           onClick={() => {
               dispatch(UIState.actions.showModal(ModalTypes.GetMoreGrove));
           }}
        >
            <img src={getMoreGroveButton}/>
        </a>
    )
}

export default GetMoreGroveButton;